import { api } from "../../api/client";

export function getLicenses() {
  return api.get("/admin/licenses");
}

export function createLicense(license) {
  return api.post("/admin/licenses", license);
}

export function deleteLicense(licenseId, sessionId) {
  return api.delete(`/admin/licenses/${licenseId}`, { data: { session_id: sessionId } });
}

export function downloadLicenseFile(licenseId) {
  return api.get(`/admin/licenses/${licenseId}/download-lic`, { responseType: "blob" });
}

export function getOfflineKey(licenseId) {
  return api.get(`/admin/licenses/${licenseId}/offline-key`);
}
